import styled from "styled-components"

export const ModalWrapper = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	right: 0;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.6);
	z-index: ${({ zIndex }) => {
		return zIndex ? zIndex : 350
	}};
	flex-flow: column;
`
export const IconWrapper = styled.div`
	position: relative;
	width: 40px;
	height: 40px;
	display: inline-block;
`
export const IconImg = styled.img``
export const LoadingTxt = styled.div`
	color: white;
	white-space: pre-line;
	text-align: center;
`
